import AsyncButton from '../../../shared/Loading/AsyncButton';

const iconByPrize = (prize, variant) => {
  if (variant === 'bonda') return 'bonda';

  const text = `${prize?.title ?? ''} ${prize?.description ?? ''}`.toLowerCase();
  if (text.includes('licencia') || text.includes('arcgis') || text.includes('pro')) return 'license';
  if (text.includes('curso') || text.includes('premium') || text.includes('acceso')) return 'course';
  return 'gift';
};

const PrizeIcon = ({ type }) => {
  const common = 'h-5 w-5';

  return (
    <span className="flex h-6 w-6 shrink-0 items-center justify-center text-personalized">
      {type === 'bonda' && (
        <svg viewBox="0 0 24 24" className={common} fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M12 3l1.5 2.4 2.8-.6.8 2.7 2.6.9-.9 2.6 1.6 2.3-2.3 1.6.1 2.8-2.8-.1-1.6 2.3-2.3-1.6-2.6.9.1-2.8-2.6-.8.9-2.6-1.6-2.4 2.3-1.6-.1-2.8 2.8.1L12 3z" />
          <path d="M9.4 12.1l1.7 1.7 3.5-3.7" />
        </svg>
      )}
      {type === 'license' && (
        <svg viewBox="0 0 24 24" className={common} fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M7 4h10a2 2 0 0 1 2 2v12l-3-2-3 2-3-2-3 2V6a2 2 0 0 1 2-2z" />
          <path d="M9 8h6M9 11h4" />
        </svg>
      )}
      {type === 'course' && (
        <svg viewBox="0 0 24 24" className={common} fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4H20v14H6.5A2.5 2.5 0 0 0 4 20.5z" />
          <path d="M4 6.5v14M8 8h8M8 11h6" />
        </svg>
      )}
      {type === 'gift' && (
        <svg viewBox="0 0 24 24" className={common} fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M4 10h16v10H4zM3 7h18v3H3zM12 7v13" />
          <path d="M12 7H8.5A2.5 2.5 0 1 1 11 4.5L12 7zM12 7h3.5A2.5 2.5 0 1 0 13 4.5L12 7z" />
        </svg>
      )}
    </span>
  );
};

const PrizeCard = ({ prize, variant, actionLabel, onAction, className = '' }) => {
  const showScore = prize?.visibleScore && prize?.prize !== undefined && prize?.prize !== null;
  const iconType = iconByPrize(prize, variant);
  const isRedeemed = Boolean(prize?.redeemed);
  const redeemedMessage = 'Producto ya canjeado, solo se puede canjear una vez por periodo';

  return (
    <div className={`profile-prize-card border border-gray-200 rounded-lg bg-gray-50 px-4 py-3 xl:flex xl:flex-col xl:justify-center xl:px-3 xl:py-2.5 ${isRedeemed ? 'opacity-75' : ''} ${className}`}>
      <div className="grid gap-2 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-start lg:gap-4">
        <div className="flex min-w-0 items-start gap-3">
          <PrizeIcon type={iconType} />
          <div className="min-w-0 flex-1">
            <h3 className="font-semibold text-base text-gray-900 leading-tight xl:text-[15px]">{prize.title}</h3>
            {prize.description && (
              <p className="mt-1.5 text-sm text-gray-700 leading-snug break-words lg:max-w-[18rem] xl:text-[13px]">
                {prize.description}
              </p>
            )}
            {isRedeemed && (
              <p className="mt-1.5 text-xs font-semibold text-orange-700">
                {redeemedMessage}
              </p>
            )}
          </div>
        </div>

        {onAction ? (
          <AsyncButton
            type="button"
            disabled={isRedeemed}
            onClick={onAction}
            className={`hidden shrink-0 rounded border px-3 py-1.5 text-sm font-semibold transition lg:inline-flex xl:text-xs ${
              isRedeemed
                ? 'cursor-not-allowed border-gray-200 bg-gray-300 text-white'
                : 'border-transparent bg-personalized text-white hover:border-personalized hover:bg-white hover:text-personalized'
            }`}
          >
            {actionLabel}
          </AsyncButton>
        ) : (
          showScore && (
            <span className="hidden shrink-0 rounded-full bg-green-100 px-3 py-1.5 text-sm font-semibold text-green-800 lg:inline-flex xl:text-xs">
              {prize.prize} Puntos
            </span>
          )
        )}
      </div>

      {onAction ? (
        <AsyncButton
          type="button"
          disabled={isRedeemed}
          onClick={onAction}
          className={`mt-2 w-full rounded border px-5 py-1.5 text-sm font-semibold transition lg:hidden ${
            isRedeemed
              ? 'cursor-not-allowed border-gray-200 bg-gray-300 text-white'
              : 'border-transparent bg-personalized text-white hover:border-personalized hover:bg-white hover:text-personalized'
          }`}
        >
          {actionLabel}
        </AsyncButton>
      ) : (
        showScore && (
          <span className="mt-2 inline-flex rounded-full bg-green-100 px-3 py-1.5 text-sm font-semibold text-green-800 lg:hidden">
            {prize.prize} Puntos
          </span>
        )
      )}
    </div>
  );
};

export default PrizeCard;
